<template>
  <div class="index-module_articleWrap_2Zphx">
      <div  class="zhemo">如何在中国做价值投资？</div>
    <div class="index-module_mediaWrap_213jB">
      <!--14--><!--15-->
      <!--16--><!--19--><!--20--><!--21-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >在资本市场里面，对于投资来说，首先要理解这个市场。中国的资本市场毫无疑问是一个非常复杂的生态系统，你以什么角度看它，它可能就以什么样的形式回馈你。</span
        >
      </p>
      <!--22--><!--23--><!--24--><!--25--><!--26--><!--27-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--28--><!--29--><!--30--><!--31--><!--32--><!--33-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong szhuang">一、理解市场，理解经济规律</span></span
        >
      </p>
      <!--34--><!--35--><!--36--><!--37--><!--38--><!--39-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--40--><!--41--><!--42--><!--43--><!--44--><!--45-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >长久以来，大家都说资本市场是一个赌场，人们是以赌博、投机的方式，以很高预期回报率的方式在参与这个市场。</span
        >
      </p>
      <!--46--><!--47--><!--48--><!--49--><!--50--><!--51-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--52--><!--53--><!--54--><!--55--><!--56--><!--57-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >但是还有另一个说法，依托研究公司的基本面，可以获得持续稳健的回报，不同的做法可能都会得到预期的结果。</span
        >
      </p>
      <!--58--><!--59--><!--60--><!--61--><!--62--><!--63-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--64--><!--65--><!--66--><!--67--><!--68--><!--69-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >总体上看，是我们的行为方式或者价值观，决定了自己参与这个市场的方式。</span
          ></span
        >
      </p>
      <!--70--><!--71--><!--72--><!--73--><!--74--><!--75-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-strong"></span></span>
      </p>
      <!--76--><!--77--><!--78--><!--79--><!--80--><!--81-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >但是市场本身，这么多年来，真正反映的还是国家、产业发展的变化，以及公司的成长。</span
          ></span
        >
      </p>
      <!--82--><!--83--><!--84--><!--85--><!--86--><!--87-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--88--><!--89--><!--90--><!--91--><!--92--><!--93-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们可以看到，很多公司最后成了很高回报的公司，在全球都有非常高的市场占有率，极具竞争优势，这个过程总体来看，还是一个反映基本面的市场。</span
        >
      </p>
      <!--94--><!--95--><!--96--><!--97--><!--98--><!--99-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--100--><!--101--><!--102--><!--103--><!--104--><!--105-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >作为一名基金经理，首先要了解自己适合什么样的研究和投资方式。还要了解行业或者公司，了解资本市场本身运行的规律，以及其他参与者的行为。</span
        >
      </p>
      <!--106--><!--107--><!--108--><!--109--><!--110--><!--111-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--112--><!--113--><!--114--><!--115--><!--116--><!--117-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我觉得同样重要的，是需要理解经济运行的一般规律。尤其当市场有剧烈变化，有重大恐慌或其他高度不确定性的事件发生的时候，对于我们来说，在资本市场的应对是非常重要的。</span
        >
      </p>
      <!--118--><!--119--><!--120--><!--121--><!--122--><!--123-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--124--><!--125--><!--126--><!--127--><!--128--><!--129-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >因为这会使你减少恐惧感，可以使你在资本市场关键的时刻，或者重大变化时刻，有信心做出独立的决策。</span
        >
      </p>
      <!--130--><!--131--><!--132--><!--133--><!--134--><!--135-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--136--><!--137--><!--138--><!--139--><!--140--><!--141-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >在资本市场上，考验基金经理或者投资人的地方，除了获得收益，还要看能不能获得超额的收益，业内称之为阿尔法。</span
        >
      </p>
      <!--142--><!--143--><!--144--><!--145--><!--146--><!--147-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--148--><!--149--><!--150--><!--151--><!--152--><!--153-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >有一种理论叫有效市场理论，说市场已经高度有效，我们很难获得超额收益。</span
          ></span
        >
      </p>
      <!--154--><!--155--><!--156--><!--157--><!--158--><!--159-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--160--><!--161--><!--162--><!--163--><!--164--><!--165-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >美国是这样的市场，我们看到过去一年、三年、五年、十年，大概只有10%
          多的基金能够打败各自的基准。从打败基准的比例来看，专业机构在美国已经很难超越市场了。毫无疑问，这是一个非常高效的市场。</span
        >
      </p>
      <!--166--><!--167--><!--168--><!--169--><!--170--><!--171-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--172--><!--173--><!--174--><!--175--><!--176--><!--177-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong">这个过程是怎么形成的？</span></span
        >
      </p>
      <!--178--><!--179--><!--180--><!--181--><!--182--><!--183-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--184--><!--185--><!--186--><!--187--><!--188--><!--189-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >很重要的一个原因是，现在信息传递的效率远高于过去任何一个时候，同时资本市场本身得到的关注也高于历史水平，有太多的人、太多的资源投入这个市场。</span
        >
      </p>
      <!--190--><!--191--><!--192--><!--193--><!--194--><!--195-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--196--><!--197--><!--198--><!--199--><!--200--><!--201-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当所有管理者更努力的时候，驱动这个市场本身能更早实现价值发现功能，也导致机构投资者更难战胜这个市场，这可能是所有市场发展到比较极端的时候的一个普遍现象，我们发现美国出现了这种现象。</span
        >
      </p>
      <!--202--><!--203--><!--204--><!--205--><!--206--><!--207-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--208--><!--209--><!--210--><!--211--><!--212--><!--213-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong">中国有重大差异的地方是：</span></span
        >
      </p>
      <!--214--><!--215--><!--216--><!--217--><!--218--><!--219-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--220--><!--221--><!--222--><!--223--><!--224--><!--225-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >第一，中国市场的参与者很多，有很多个人、机构，甚至不太理解资本市场的不专业的机构。因为这种多元的参与，使市场的效率没有那么高，给这个市场创造阿尔法提供了比较好的外部土壤。</span
        >
      </p>
      <!--226--><!--227--><!--228--><!--229--><!--230--><!--231-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--232--><!--233--><!--234--><!--235--><!--236--><!--237-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >第二，即使是专业机构，因为公司治理、考核机制，造成投资行为出现非常大的扭曲，这种扭曲事实上会导致市场经常出现无效。</span
        >
      </p>
      <!--238--><!--239--><!--240--><!--241--><!--242--><!--243-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--244--><!--245--><!--246--><!--247--><!--248--><!--249-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >回过头来看，一些恍如隔世的情况会阶段性地经常出现，就人类本身来说，我们都有这些天然的弱点，知识可以积累，但智慧还是很难同步达到。</span
        >
      </p>
      <!--250--><!--251--><!--252--><!--253--><!--254--><!--255-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--256--><!--257--><!--258--><!--259--><!--260--><!--261-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >因为这些原因，资本市场还会有阶段性、间歇性，甚至是很长一段时间非常多的无效率的情况出现。</span
        >
      </p>
      <!--262--><!--263--><!--264--><!--265--><!--266--><!--267-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--268--><!--269--><!--270--><!--271--><!--272--><!--273-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2013—2015
          年，传统行业因为需求放缓，经营压力变大，进入调整阶段，互联网行业却飞速发展，日新月异。</span
        >
      </p>
      <!--274--><!--275--><!--276--><!--277--><!--278--><!--279-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--280--><!--281--><!--282--><!--283--><!--284--><!--285-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >巨大的反差使传统行业的公司非常恐慌，全社会形成共识，需要向互联网转型。这种思潮折射到资本市场上，发展到极致，也形成很大的扭曲。</span
          ></span
        >
      </p>
      <!--286--><!--287--><!--288--><!--289--><!--290--><!--291-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--292--><!--293--><!--294--><!--295--><!--296--><!--297-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >大家一方面对转型的方向有过高的预期，另一方面却导致那些本身竞争结构比较稳定的行业容易被市场所忽视。</span
        >
      </p>
      <!--298--><!--299--><!--300--><!--301--><!--302--><!--303-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--304--><!--305--><!--306--><!--307--><!--308--><!--309-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >同时我们可以看到，当互联网对各个行业的影响已经高度明确化，市场的不确定性下降了之后，过去这些行业被低估的部分，又在2016
          年、2017 年得到了资本市场比较大的修正。</span
        >
      </p>
      <!--310--><!--311--><!--312--><!--313--><!--314--><!--315-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--316--><!--317--><!--318--><!--319--><!--320--><!--321-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这本身是一个市场阶段性没有效率，也会阶段性有效率的过程。</span
        >
      </p>
      <!--322--><!--323--><!--324--><!--325--><!--326--><!--327-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--376--><!--377--><!--378--><!--379--><!--380--><!--381-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong szhuang">二、建立自己的坐标系</span></span
        >
      </p>
      <!--382--><!--383--><!--384--><!--385--><!--386--><!--387-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--388--><!--389--><!--390--><!--391--><!--392--><!--393-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >对于做研究或者做投资来说，我们总是希望自己能够发现这个市场无效率的部分，怎么做？从自身体会来说，我希望建立一个参照系，通过研究，能够对未来有所判断或者是预测。</span
        >
      </p>
      <!--394--><!--395--><!--396--><!--397--><!--398--><!--399-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--400--><!--401--><!--402--><!--403--><!--404--><!--405-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我是在1996
          年本科毕业以后到深圳开始接触资本市场，当时市场是一个庄股横行的年代。研究生毕业，2001
          年到国泰君安证券的时候，正好又经历了股票市场从一个庄股横行到做庄模式破灭的阶段。</span
        >
      </p>
      <!--406--><!--407--><!--408--><!--409--><!--410--><!--411-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--412--><!--413--><!--414--><!--415--><!--416--><!--417-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >从2003
          年开始，整个行业寻找一个可持续的方向，开始去关注企业的竞争力、公司的基本面，投资逐渐向国际规范靠拢，那是一个国内机构投资者最关注企业质量和竞争优势的阶段。</span
        >
      </p>
      <!--418--><!--419--><!--420--><!--421--><!--422--><!--423-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--424--><!--425--><!--426--><!--427--><!--428--><!--429-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >但是在2007
          年之后，随着股权分置改革完成，大股东成为上市公司股价影响最大的一股力量。2009
          年以后，大股东对于资本市场的影响程度，到了一个史无前例的高度，甚至在短期之内产生很大的扭曲。</span
        >
      </p>
      <!--430--><!--431--><!--432--><!--433--><!--434--><!--435-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--436--><!--437--><!--438--><!--439--><!--440--><!--441-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >不同的阶段都有不同的事情发生，我自己的体会是，在这个市场上，还是可以通过做基础研究，发现公司的未来价值创造，从而得到持续稳定的回报，获得一个长期的超额收益。</span
        >
      </p>
      <!--442--><!--443--><!--444--><!--445--><!--446--><!--447-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--448--><!--449--><!--450--><!--451--><!--452--><!--453-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >简单地说，选回报率高的行业，找到非常优秀的公司，在合适的价格做投资。</span
          ></span
        >
      </p>
      <!--454--><!--455--><!--456--><!--457--><!--458--><!--459-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--460--><!--461--><!--462--><!--463--><!--464--><!--465-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >所有的投资，估值水平一定是最重要的，也就是价格，因为价格决定了回报率。再优秀的公司，价格过高也可能会给你比较低的回报率，甚至负回报率，这是无法避免的。</span
        >
      </p>
      <!--466--><!--467--><!--468--><!--469--><!--470--><!--471-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--472--><!--473--><!--474--><!--475--><!--476--><!--477-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们的投资，是希望面向未来，通过分享企业的价值创造来实现投资回报，这个过程需要我们去更多的判断企业的未来，这是我们做研究的根本目的。</span
        >
      </p>
      <!--478--><!--479--><!--480--><!--481--><!--482--><!--483-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--484--><!--485--><!--486--><!--487--><!--488--><!--489-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们研究过去，研究历史，是为了能够更好地、更大概率地去分析和判断企业、行业的未来发展。</span
        >
      </p>
      <!--490--><!--491--><!--492--><!--493--><!--494--><!--495-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--496--><!--497--><!--498--><!--499--><!--500--><!--501-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >在这之前，我们在做行业研究和积累的时候怎么建立框架？</span
          ></span
        >
      </p>
      <!--502--><!--503--><!--504--><!--505--><!--506--><!--507-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--508--><!--509--><!--510--><!--511--><!--512--><!--513-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我发现有一个比较好的类比的参照系，我们研究了当时美国标准普尔500
          指数的行业结构分布和利润分布。</span
        >
      </p>
      <!--514--><!--515--><!--516--><!--517--><!--518--><!--519-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--520--><!--521--><!--522--><!--523--><!--524--><!--525-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >美国是一个大国，中国也是一个大国，美国的产业非常全，中国的产业也很全，这是一个非常好的参照系。</span
        >
      </p>
      <!--526--><!--527--><!--528--><!--529--><!--530--><!--531-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--532--><!--533--><!--534--><!--535--><!--536--><!--537-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们可以观察标准普尔500 指数过去40
          年的数据，初步形成一个框架。可以看到，在一个大国里面，随着经济发展、产业成熟，不同的行业在不同的阶段有不同的分布。</span
        >
      </p>
      <!--538--><!--539--><!--540--><!--541--><!--542--><!--543-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--544--><!--545--><!--546--><!--547--><!--548--><!--549-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >金融行业永远是一个大行业，它关系所有的人，也关系整个经济活动的运行。</span
          ></span
        >
      </p>
      <!--550--><!--551--><!--552--><!--553--><!--554--><!--555-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--556--><!--557--><!--558--><!--559--><!--560--><!--561-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >在格林斯潘几次降息以后，美国金融泡沫时期，这个行业最高占到标准普尔500
          指数市值的22%，2012 年大概是16%。</span
        >
      </p>
      <!--562--><!--563--><!--564--><!--565--><!--566--><!--567-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--568--><!--569--><!--570--><!--571--><!--572--><!--573-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >医疗行业一直是一个非常重要的行业，占美国GDP 大概15%
          以上，在标准普尔500
          指数的市值结构里面，它也一直是一个排名前三位的重要行业。</span
        >
      </p>
      <!--574--><!--575--><!--576--><!--577--><!--578--><!--579-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--580--><!--581--><!--582--><!--583--><!--584--><!--585-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >高科技行业是美国最大的一个行业，2012 年占标准普尔500
          指数市值的18%，目前肯定更高，我估计大概是24% ～ 25%。但是2000
          年之前，在互联网泡沫时，该行业占整个市场市值接近1/3。</span
        >
      </p>
      <!--586--><!--587--><!--588--><!--589--><!--590--><!--591-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--592--><!--593--><!--594--><!--595--><!--596--><!--597-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >可选消费（也就是耐用消费品）和日常消费一直是两个比较稳定的行业，它的长期比例都是在10%。</span
        >
      </p>
      <!--598--><!--599--><!--600--><!--601--><!--602--><!--603-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--604--><!--605--><!--606--><!--607--><!--608--><!--609-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >美国确实是一个非常稳健的经济体，它的制造工业在GDP
          中的比重一直都维持在10% 左右。虽然就业人群的比例在下降，但是过去40
          年来，总体上维持着比较高而稳定的市值比例，美国的制造业还是很有生命力和竞争力的。</span
        >
      </p>
      <!--610--><!--611--><!--612--><!--613--><!--614--><!--615-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--616--><!--617--><!--618--><!--619--><!--620--><!--621-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >像电信服务、公用事业、大宗商品、原材料这些行业，随着国家发展的成熟，这些行业在经济结构里面所占的比例是下降的。</span
        >
      </p>
      <!--622--><!--623--><!--624--><!--625--><!--626--><!--627-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--628--><!--629--><!--630--><!--631--><!--632--><!--633-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >能源行业是一个很大的行业，这主要以石油和天然气为代表。但未来这个行业会不会发生大的变化，比如当交通电动化以后，汽油不再是重要的燃料，也许这个行业会发生重大的变化。</span
        >
      </p>
      <!--634--><!--635--><!--636--><!--637--><!--638--><!--639-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--640--><!--641--><!--642--><!--643--><!--644--><!--645-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这些行业的利润占标准普尔500
          指数的比例，相当于做了一个市值加权。</span
        >
      </p>
      <!--646--><!--647--><!--648--><!--649--><!--650--><!--651-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--652--><!--653--><!--654--><!--655--><!--656--><!--657-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >比如医疗行业市盈率长期高于整体是很容易理解的。至于电信和公用事业，我觉得是因为这些行业在美国处于稳定的状态，风险贴现比较低。</span
        >
      </p>
      <!--658--><!--659--><!--660--><!--661--><!--662--><!--663-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--664--><!--665--><!--666--><!--667--><!--668--><!--669-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >而2009
          年之后，整个美国资本市场是一个长期利率下行，甚至走向一个超低利率的阶段，这个时候稳定的行业，估值水平容易略高。</span
        >
      </p>
      <!--670--><!--671--><!--672--><!--673--><!--674--><!--675-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--676--><!--677--><!--678--><!--679--><!--680--><!--681-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >金融行业的估值水平一般是低于平均水平的，主要因为这是一个高杠杆的行业，同时因为委托代理机制，用其他人的钱去冒险，导致金融行业的风险更大，所以必须有一个高的风险溢价。</span
          ></span
        >
      </p>
      <!--682--><!--683--><!--684--><!--685--><!--686--><!--687-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--688--><!--689--><!--690--><!--691--><!--692--><!--693-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >有意思的是，科技行业的利润比例高于它的市值比例，我觉得背后的含义可能是，科技行业作为一个整体，确实有一个比较高的风险溢价，市场并没有给它更高的估值。</span
        >
      </p>
      <!--694--><!--695--><!--696--><!--697--><!--698--><!--699-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--700--><!--701--><!--702--><!--703--><!--704--><!--705-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >或者说当公司比较小的时候，存在不确定性的时候，会有比较高的估值；当公司壮大了之后，估值会下降。</span
        >
      </p>
      <!--706--><!--707--><!--708--><!--709--><!--710--><!--711-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--712--><!--713--><!--714--><!--715--><!--716--><!--717-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当然从最近五年发生的变化来看，尤其是近两三年，美国最大的一批互联网公司在最大体量上实现了高速增长，这是一个前所未有的变化，因为互联网可以更广泛地接触到C
          端所有的人群。</span
        >
      </p>
      <!--718--><!--719--><!--720--><!--721--><!--722--><!--723-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--724--><!--725--><!--726--><!--727--><!--728--><!--729-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >消费品行业总体来看，是一个估值水平和整个系统市场接近的状态，有一些时候略高。</span
        >
      </p>
      <!--730--><!--731--><!--732--><!--733--><!--734--><!--735-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--736--><!--737--><!--738--><!--739--><!--740--><!--741-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >能源行业长期的估值水平低于其他行业，我觉得主要原因是大家对于这种情况的可持续性抱有一定的怀疑。</span
        >
      </p>
      <!--742--><!--743--><!--744--><!--745--><!--746--><!--747-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--748--><!--749--><!--750--><!--751--><!--752--><!--753-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们做研究，本质是收集信息和数据，然后再分析处理这些数据。我们希望能够理解背后的商业逻辑，也希望自己能够有洞察力，能够预测未来，能够指导我们的投资，这个过程需要我们不断地用现实去检验和修正。</span
        >
      </p>
      <!--754--><!--755--><!--756--><!--757--><!--758--><!--759-->
    </div>
    
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--808--><!--809--><!--810--><!--811--><!--812--><!--813-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong szhuang">三、华为、中兴在全球兴起的原因</span></span
        >
      </p>
      <!--814--><!--815--><!--816--><!--817--><!--818--><!--819-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--820--><!--821--><!--822--><!--823--><!--824--><!--825-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >从20 世纪90
          年代开始，中国通信行业的公司发展到今天，逐渐改写了全球的产业格局。</span
        >
      </p>
      <!--826--><!--827--><!--828--><!--829--><!--830--><!--831-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--832--><!--833--><!--834--><!--835--><!--836--><!--837-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2003 年、2004
          年的时候我能够从研究岗转到投资岗，是因为我当时做的通信行业的研究。现在回顾当时的研究，有很多体会。</span
        >
      </p>
      <!--838--><!--839--><!--840--><!--841--><!--842--><!--843-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--844--><!--845--><!--846--><!--847--><!--848--><!--849-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2003 年、2004
          年通信行业正在发生重大变化，华为、中兴为代表的公司依托一个庞大的本土市场，也利用了中国特有的劳动力成本优势，迅速崛起。</span
        >
      </p>
      <!--850--><!--851--><!--852--><!--853--><!--854--><!--855-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--856--><!--857--><!--858--><!--859--><!--860--><!--861-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >通信行业是一个人力资本高度密集的行业，研发人员往往占到公司的1/3
          甚至更高，这个行业的一般结构是毛利率在30% ～ 50%
          之间，研发费用大概占10% ～
          15%（主要是人力成本），销售费用占10%（主要是直销为代表的高销售费用的商业模式）。</span
        >
      </p>
      <!--862--><!--863--><!--864--><!--865--><!--866--><!--867-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--868--><!--869--><!--870--><!--871--><!--872--><!--873-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >中国公司在2000
          年左右形成了结构性的优势。比如在劳动力成本上，中国的大学培养了非常优秀的大批工程师，加入到华为、中兴这样的体系。</span
        >
      </p>
      <!--874--><!--875--><!--876--><!--877--><!--878--><!--879-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--880--><!--881--><!--882--><!--883--><!--884--><!--885-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这些公司就可以中国的成本结构应对世界上最优秀的一批公司，包括有很多传奇的公司，比如以贝尔实验室为后盾的朗讯，曾被称为“诺贝尔奖的摇篮”。</span
        >
      </p>
      <!--886--><!--887--><!--888--><!--889--><!--890--><!--891-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--892--><!--893--><!--894--><!--895--><!--896--><!--897-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >因为这样一个结构性成本的劣势，这些跨国公司在中国被打败，在全球也被蚕食。它们失败的原因，在当时已经可以清楚地判断出来，首要一点是因为战略失误。</span
        >
      </p>
      <!--898--><!--899--><!--900--><!--901--><!--902--><!--903-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--904--><!--905--><!--906--><!--907--><!--908--><!--909-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >从前通信行业是只有发达国家的少数公司能够从事的高壁垒行业，它们在中国执行教科书式的高定价的撇脂战略。这个高价格给了中国公司机会。</span
          ></span
        >
      </p>
      <!--910--><!--911--><!--912--><!--913--><!--914--><!--915-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--916--><!--917--><!--918--><!--919--><!--920--><!--921-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们知道，早期不管是华为、中兴、大唐还是巨龙，产品性能较差，但是海外供应商的价格太高了。国内公司走性价比路线，以较低价格销售产品，还是有非常高的利润。然后用所获利润去研发、去改善产品。</span
        >
      </p>
      <!--922--><!--923--><!--924--><!--925--><!--926--><!--927-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--928--><!--929--><!--930--><!--931--><!--932--><!--933-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我记得在20 世纪90 年代，程控交换机一线大概卖 1500 元到 2000
          元。因为这么高的价格，所以国内的公司能够有切入的机会，等到国内的公司逐渐成长起来之后，出现了新的情况。</span
        >
      </p>
      <!--934--><!--935--><!--936--><!--937--><!--938--><!--939-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--940--><!--941--><!--942--><!--943--><!--944--><!--945-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这些公司大力招聘优秀大学生去做市场和研发，两条腿都走得很好。它们在市场体系中最紧密地贴近运营商的需求，然后传导到研发体系，这样就变成了不只是有一个成本优势的公司，而是变成了一个更理解客户需求的公司。</span
        >
      </p>
      <!--946--><!--947--><!--948--><!--949--><!--950--><!--951-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--952--><!--953--><!--954--><!--955--><!--956--><!--957-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >跨国企业的中国分部是由职业经理人管理，考核机制决定了他们更在意短期的财务指标，无法做出战略决策和整体性考虑。他们在中国的研发基本上只是形象工程，最多只是全球产品的小修改，无法把中国客户的需求发展成为产品定义。</span
        >
      </p>
      <!--958--><!--959--><!--960--><!--961--><!--962--><!--963-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--964--><!--965--><!--966--><!--967--><!--968--><!--969-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >20 世纪90
          年代的时候他们有巨大的性能优势，中国的公司只能做价格竞争。但是2000年之后，中国公司的产品性能逐渐赶上来了，而且能够更理解客户的需求，把客户的需求融入到产品开发中去。</span
        >
      </p>
      <!--970--><!--971--><!--972--><!--973--><!--974--><!--975-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--976--><!--977--><!--978--><!--979--><!--980--><!--981-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们能提供更好的产品，通过这个途径不断把竞争对手赶出中国市场。我觉得归根到底，这是一个创业型的公司与一个职业经理人竞争的结果，他们应对不同的市场，做出了不同的选择。</span
        >
      </p>
      <!--982--><!--983--><!--984--><!--985--><!--986--><!--987-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--988--><!--989--><!--990--><!--991--><!--992--><!--993-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >下一步，像华为这样的公司，它们非常有进取精神，未来可以扩展到全球市场，虽然这条路非常漫长，但是它们一定能成功，根本原因是从前所有的跨国企业在其他国家的市场也是一个高定价的业务模式。</span
          >当中国的公司走出去之后，会成为发展中国家解决通信问题的最好的合作伙伴，为客户提供巨大的价值。在发达国家市场，它们会成为运营商降低成本最主要的伙伴。</span
        >
      </p>
      <!--994--><!--995--><!--996--><!--997--><!--998--><!--999-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1000--><!--1001--><!--1002--><!--1003--><!--1004--><!--1005-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >华为首先在2001 年、2002
          年开始了这个进程，中兴可能更晚才作为一个运营商约束华为的棋子，被引入了跨国运营商的供应链体系。</span
        >
      </p>
      <!--1006--><!--1007--><!--1008--><!--1009--><!--1010--><!--1011-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1012--><!--1013--><!--1014--><!--1015--><!--1016--><!--1017-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >我们可以从逻辑上面分析这个过程。</span
          ></span
        >
      </p>
      <!--1018--><!--1019--><!--1020--><!--1021--><!--1022--><!--1023-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1024--><!--1025--><!--1026--><!--1027--><!--1028--><!--1029-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2003
          年的时候，跨国公司和中国公司的收入规模差别很大，但是从人力资源的分布来看，研发人员基本上都在1
          万人左右的量级，这个时候已经没有差距了，虽然中国公司的研发费用只有跨国公司的1/10。</span
        >
      </p>
      <!--1030--><!--1031--><!--1032--><!--1033--><!--1034--><!--1035-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1036--><!--1037--><!--1038--><!--1039--><!--1040--><!--1041-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >通信行业的公司，基本上都是把10% ～ 15%
          的收入拿来做研发，但是因为当时中国工程师的工资低，基本上一年 20 万元到
          30 万元，而国外要 20 多万美元，这就是一个结构性的竞争优势。</span
        >
      </p>
      <!--1042--><!--1043--><!--1044--><!--1045--><!--1046--><!--1047-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1048--><!--1049--><!--1050--><!--1051--><!--1052--><!--1053-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当然现在不一样了，中国互联网巨头的人均年薪也都到了20 多万美元。15
          年前，虽然从销售收入的规模来看，中国公司显得弱小，但是从一个体系来看，已经和跨国公司在同样一个量级了。</span
        >
      </p>
      <!--1054--><!--1055--><!--1056--><!--1057--><!--1058--><!--1059-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1060--><!--1061--><!--1062--><!--1063--><!--1064--><!--1065-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2003 年的时候有很多知名的公司，但是后来，朗讯2006
          年被阿尔卡特以134亿美元收购，朗讯的市值在2004 年有150 亿美元。</span
        >
      </p>
      <!--1066--><!--1067--><!--1068--><!--1069--><!--1070--><!--1071-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1072--><!--1073--><!--1074--><!--1075--><!--1076--><!--1077-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2000 年的时候，朗讯为了收购ASCEND 公司花了大概200
          亿美元，当然那个时候朗讯的市值是1 000 多亿美元，跌下来了。</span
        >
      </p>
      <!--1078--><!--1079--><!--1080--><!--1081--><!--1082--><!--1083-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1084--><!--1085--><!--1086--><!--1087--><!--1088--><!--1089-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >后来阿尔卡特朗讯在2015 年又整体被诺基亚以166
          亿美元收购了，收购之后诺基亚目前整体的市值也只有300
          多亿美元，收入只有200 多亿美元（见表11-1）。</span
        >
      </p>
      <!--1090--><!--1091--><!--1092--><!--1093--><!--1094--><!--1095-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1096--><!--1097--><!--1098--><!--1099--><!--1100--><!--1101-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >产业结构发生了巨大的变化，全球的价值链在发生巨大的转移，这是过去15年通信设备行业发生的事情。</span
        >
      </p>
      <!--1102--><!--1103--><!--1104--><!--1105--><!--1106--><!--1107-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1108--><!--1109--><!--1110--><!--1111--><!--1112--><!--1113-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >整个欧美通信设备行业，除了思科因为受益于美国封闭的市场不让我们进去，中国的公司已经完全主导了这个市场。现在全球通信设备行业的玩家只剩下爱立信、诺基亚、华为、中兴4
          家公司，所以有人说中国是发达国家的粉碎机。<span class="bjh-br"></span
        ></span>
      </p>
      <!--1114--><!--1115--><!--1116--><!--1117--><!--1118--><!--1119-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1120--><!--1121--><!--1122--><!--1123--><!--1124--><!--1125-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们其实可以从通信行业看出来，这可是孕育了无数诺贝尔奖的行业，也曾经是高科技行业的代表，当然后面已经成熟了。</span
        >
      </p>
      <!--1126--><!--1127--><!--1128--><!--1129--><!--1130--><!--1131-->
    </div>
    <img src="../../../assets/img/gar1-1.jpg" alt="">
    
    <div class="index-module_mediaWrap_213jB">
      <!--1138--><!--1139-->
      <!--1140--><!--1143--><!--1144--><!--1145-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p">表11-1 通信设备商对比</span></p>
      <!--1146--><!--1147--><!--1148--><!--1149--><!--1150--><!--1151-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1132--><!--1133--><!--1134--><!--1135--><!--1136--><!--1137-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong szhuang">四、市场对中国银行业存在误解</span></span
        >
      </p>
      <!--1152--><!--1153--><!--1154--><!--1155--><!--1156--><!--1157-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1158--><!--1159--><!--1160--><!--1161--><!--1162--><!--1163-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >银行业本质上是一个资产负债表的生意、重资本行业，有资本金的需求，要放贷款必须有资本金，这是一个杠杆率的约束，这个生意很古老。</span
        >
      </p>
      <!--1164--><!--1165--><!--1166--><!--1167--><!--1168--><!--1169-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1170--><!--1171--><!--1172--><!--1173--><!--1174--><!--1175-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >中国银行业背负了特别多的负面看法，广为流传的有：</span
        >
      </p>
      <!--1176--><!--1177--><!--1178--><!--1179--><!--1180--><!--1181-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1182--><!--1183--><!--1184--><!--1185--><!--1186--><!--1187-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-blockquote"
          ><span class="bjh-p"
            >中国银行业暴利，这个行业的利润占比过高，整个上市公司利润的一半是银行的。</span
          ><span class="bjh-p"><span class="bjh-br"></span></span
          ><span class="bjh-p"
            >中国银行业的高利润来自于政策保护、竞争不充分，都认为中国的银行业利差过大，在利率市场化之后，一定会有急剧下降。</span
          ><span class="bjh-p"><span class="bjh-br"></span></span
          ><span class="bjh-p"
            >中国企业的坏账很多，目前银行的坏账没有反应，远远低于实际的情况。</span
          ></span
        >
      </p>
      <!--1188--><!--1189--><!--1190--><!--1191--><!--1192--><!--1193-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1194--><!--1195--><!--1196--><!--1197--><!--1198--><!--1199-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >作为研究者，我们要客观地分析数据，寻找背后真正的答案。</span
        >
      </p>
      <!--1200--><!--1201--><!--1202--><!--1203--><!--1204--><!--1205-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1206--><!--1207--><!--1208--><!--1209--><!--1210--><!--1211-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >首先我们看银行业，甚至是金融业利润占比的问题。</span
          ></span
        >
      </p>
      <!--1212--><!--1213--><!--1214--><!--1215--><!--1216--><!--1217-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1218--><!--1219--><!--1220--><!--1221--><!--1222--><!--1223-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >对于第一种看法，我觉得坐标系选错了，因为我国主要的银行基本都上市了，所以上市银行的利润基本等于行业的利润，而中国企业有很多公司在海外上市，同时其他非上市企业的利润比例也很高。</span
        >
      </p>
      <!--1224--><!--1225--><!--1226--><!--1227--><!--1228--><!--1229-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1230--><!--1231--><!--1232--><!--1233--><!--1234--><!--1235-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们用一个简单的数据来对比，整个银行业 1 年的利润大概 1
          万多亿元，而我们光规模以上工业企业的利润在2016 年其实超过了6
          万亿元，如果考虑房地产还有1万亿元的利润，中国银行业的整体利润占中国企业利润的比率大概是在15%以下，这是一个合适的比例。</span
        >
      </p>
      <!--1236--><!--1237--><!--1238--><!--1239--><!--1240--><!--1241-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1242--><!--1243--><!--1244--><!--1245--><!--1246--><!--1247-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >中国银行业的利润占整个金融业利润的比例非常高，这是我国的融资结构或者资产分布所决定的。</span
          ></span
        >
      </p>
      <!--1248--><!--1249--><!--1250--><!--1251--><!--1252--><!--1253-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1254--><!--1255--><!--1256--><!--1257--><!--1258--><!--1259-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >对于第二种说法，我们看一下息差。</span
          ></span
        >
      </p>
      <!--1260--><!--1261--><!--1262--><!--1263--><!--1264--><!--1265-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1266--><!--1267--><!--1268--><!--1269--><!--1270--><!--1271-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >从中国和其他国家的息差对比来看，我们处于中等水平，所有的发展中国家的利差一定远远高于中国，发达国家只有那些陷入低速增长的接近零利率的国家，利差才低于中国。</span
        >
      </p>
      <!--1272--><!--1273--><!--1274--><!--1275--><!--1276--><!--1277-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1278--><!--1279--><!--1280--><!--1281--><!--1282--><!--1283-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们应该更深层次地去想，银行的利差是怎么决定的，本质上它反映资金的回报率和信用风险，应该和GDP
          的增速（名义GDP
          的增速）是相关的，它其实应该和社会的回报率是相关的。</span
        >
      </p>
      <!--1284--><!--1285--><!--1286--><!--1287--><!--1288--><!--1289-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1290--><!--1291--><!--1292--><!--1293--><!--1294--><!--1295-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >从这个角度来讲，其实中国的银行利差是一个偏低的水平，或者整个中国的利率都是一个偏低的水平。</span
        >
      </p>
      <!--1296--><!--1297--><!--1298--><!--1299--><!--1300--><!--1301-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1302--><!--1303--><!--1304--><!--1305--><!--1306--><!--1307-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >我们可以看到，改革开放之后，一直到最近，中国的金融结构是鼓励借钱的人在占持有存款的各方的便宜，这是一个国家鼓励制造业或者说鼓励投资的一个结构。</span
          ></span
        >
      </p>
      <!--1308--><!--1309--><!--1310--><!--1311--><!--1312--><!--1313-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1314--><!--1315--><!--1316--><!--1317--><!--1318--><!--1319-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当然，我们可以说这是成功的结构，因为其他发展中国家的GDP
          增速比较高的时候，利率一定都很高，只有中国是一个例外。</span
        >
      </p>
      <!--1320--><!--1321--><!--1322--><!--1323--><!--1324--><!--1325-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1326--><!--1327--><!--1328--><!--1329--><!--1330--><!--1331-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们研究了所有的东南亚国家、拉美一些国家，以及中国台湾、香港，在它们的目前阶段和曾经的高速增长阶段，银行利率都在一个比较高的水平。而中国确实是金融扭曲，这个扭曲是鼓励借钱的人扩大再生产，收入分配上不利于拥有存款的人。</span
        >
      </p>
      <!--1332--><!--1333--><!--1334--><!--1335--><!--1336--><!--1337-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1338--><!--1339--><!--1340--><!--1341--><!--1342--><!--1343-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >银行为什么赚钱，很简单的一个指标是成本收入比。将中国和美国的银行做一个对比，我们是一个持续下降的阶段，远低于美国银行业的水平。和全球其他国家的银行做一个对比，我们也是最低的。</span
        >
      </p>
      <!--1344--><!--1345--><!--1346--><!--1347--><!--1348--><!--1349-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1350--><!--1351--><!--1352--><!--1353--><!--1354--><!--1355-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >为什么？我们看到，过去10
            年，银行业的劳动生产率在迅速提高，银行的资产增加了4
            倍，员工增加了40%，单人对应的资产是一条30
            度角的斜线，一路往上走。</span
          ></span
        >
      </p>
      <!--1356--><!--1357--><!--1358--><!--1359--><!--1360--><!--1361-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1362--><!--1363--><!--1364--><!--1365--><!--1366--><!--1367-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >所以我们会发现，中国的银行如果和发达国家的银行做对比，我们人均的资产对应是接近的，但是我们人均的工资是有差异的。</span
        >
      </p>
      <!--1368--><!--1369--><!--1370--><!--1371--><!--1372--><!--1373-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1374--><!--1375--><!--1376--><!--1377--><!--1378--><!--1379-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >虽然中国银行业的工资水平总体比较高，但是低于国外同行。国外银行业基本上将1/3
          的收入付给员工，中国比它们低了18%。这本身构成了一个巨大差异的基础，这是中国银行业能够持续有一个比较好回报的原因。</span
        >
      </p>
      <!--1380--><!--1381--><!--1382--><!--1383--><!--1384--><!--1385-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1386--><!--1387--><!--1388--><!--1389--><!--1390--><!--1391-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >中国的银行，1 元的资产，银行的净利差和中间业务收入可能产生300
          多个BP的收入。</span
        >
      </p>
      <!--1392--><!--1393--><!--1394--><!--1395--><!--1396--><!--1397-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1398--><!--1399--><!--1400--><!--1401--><!--1402--><!--1403-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >员工成本大概40 ～ 50 个BP，其他费用大概40 ～ 50 个BP，还有200 多个BP
          的拨备前利润，提100 多个BP
          拨备的话，回报率还是挺高的，资产回报率还是能够做到1% 的。</span
        >
      </p>
      <!--1404--><!--1405--><!--1406--><!--1407--><!--1408--><!--1409-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1410--><!--1411--><!--1412--><!--1413--><!--1414--><!--1415-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >对于第三种说法，全世界最极端的例子是日本的银行。</span
          ></span
        >
      </p>
      <!--1416--><!--1417--><!--1418--><!--1419--><!--1420--><!--1421-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1422--><!--1423--><!--1424--><!--1425--><!--1426--><!--1427-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们研究日本银行的历史，尤其是从20 世纪90
          年代经济泡沫破灭之后，到完全消化它的资产问题这段期间的历史。</span
        >
      </p>
      <!--1428--><!--1429--><!--1430--><!--1431--><!--1432--><!--1433-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1434--><!--1435--><!--1436--><!--1437--><!--1438--><!--1439-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >从1994 年到2005 年，整个日本银行业经历了完整周期，累计处理了91
          万亿日元的不良贷款，占整个贷款的18%，这就是日本的代价，日本银行业的代价。</span
        >
      </p>
      <!--1440--><!--1441--><!--1442--><!--1443--><!--1444--><!--1445-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1446--><!--1447--><!--1448--><!--1449--><!--1450--><!--1451-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >反观我们自己，2011
          年温州首先爆发了金融危机，因为钢铁贸易、国家宏观调控，加上大宗商品的损失和房地产，整个温州出现了很大的问题。</span
        >
      </p>
      <!--1452--><!--1453--><!--1454--><!--1455--><!--1456--><!--1457-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1458--><!--1459--><!--1460--><!--1461--><!--1462--><!--1463-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >经过5 年时间，温州的银行出现了根本转变。从2011 年到2016
          年，温州累计处理了不良贷款大概1 400 亿元。</span
        >
      </p>
      <!--1464--><!--1465--><!--1466--><!--1467--><!--1468--><!--1469-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1470--><!--1471--><!--1472--><!--1473--><!--1474--><!--1475-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >而在2016 年6 月份，它的贷款余额是7 800 亿元，基本上18%
          的贷款被处理掉。如果我们按照清收比例30%、损失比例70%
          来估算，温州贷款的12%损失掉了。</span
        >
      </p>
      <!--1476--><!--1477--><!--1478--><!--1479--><!--1480--><!--1481-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1482--><!--1483--><!--1484--><!--1485--><!--1486--><!--1487-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这是一个参照，我们做研究需要有样本和参照，这个是坏账周期的结果，对于我们未来的判断至少有了一根标尺。</span
        >
      </p>
      <!--1488--><!--1489--><!--1490--><!--1491--><!--1492--><!--1493-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1494--><!--1495--><!--1496--><!--1497--><!--1498--><!--1499-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们统计最大的8 家银行，到2016 年，它们已经累计确认了3
          万亿元表内贷款的坏账，基本占贷款余额的6.5%，拨备大概5%。</span
        >
      </p>
      <!--1500--><!--1501--><!--1502--><!--1503--><!--1504--><!--1505-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1506--><!--1507--><!--1508--><!--1509--><!--1510--><!--1511-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >毫无疑问，我认为坏账过程已经过了大半，即使我们考虑中国的银行体系经历十几个点坏账的极端情况。2016
          年以来，随着大宗商品价格上涨，我们看到银行业已经摆脱了坏账周期的高峰。</span
        >
      </p>
      <!--1512--><!--1513--><!--1514--><!--1515--><!--1516--><!--1517-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1518--><!--1519--><!--1520--><!--1521--><!--1522--><!--1523-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong">我们怎么判断银行的位置？</span></span
        >
      </p>
      <!--1524--><!--1525--><!--1526--><!--1527--><!--1528--><!--1529-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1530--><!--1531--><!--1532--><!--1533--><!--1534--><!--1535-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-blockquote"
          ><span class="bjh-p">一是判断资产质量周期，坏账周期；</span
          ><span class="bjh-p">二是要更深一步理解银行业务的特点。</span></span
        >
      </p>
      <!--1536--><!--1537--><!--1538--><!--1539--><!--1540--><!--1541-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1542--><!--1543--><!--1544--><!--1545--><!--1546--><!--1547-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >在经济发展的早期工业化阶段，也即基础设施投资的高峰阶段，整个社会的贷款需求是以企业、政府为主的对公业务，这个时候的银行一定是对公业务主导的银行。</span
        >
      </p>
      <!--1548--><!--1549--><!--1550--><!--1551--><!--1552--><!--1553-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1554--><!--1555--><!--1556--><!--1557--><!--1558--><!--1559-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我国银行业的发展一直走在这样一个轨迹上面，当它做到极致的时候，生产率最高的时候，也会面临挑战，因为发展到一定程度之后，你会发现企业的贷款需求下来了，而变成消费者成为主要的贷款需求的增长方，比如房贷、消费贷。</span
        >
      </p>
      <!--1560--><!--1561--><!--1562--><!--1563--><!--1564--><!--1565-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1566--><!--1567--><!--1568--><!--1569--><!--1570--><!--1571-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >其实，银行的业务模式本质上和我们经济发展的阶段是要去匹配、去适应的。</span
        >
      </p>
      <!--1572--><!--1573--><!--1574--><!--1575--><!--1576--><!--1577-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1578--><!--1579--><!--1580--><!--1581--><!--1582--><!--1583-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这几年一个很大的变化是，以腾讯和阿里为代表的互联网公司，开始利用自己接触客户的手段，实际上是改变了银行业的游戏规则，甚至是降低了银行业发展零售业务的天花板。</span
        >
      </p>
      <!--1584--><!--1585--><!--1586--><!--1587--><!--1588--><!--1589-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1590--><!--1591--><!--1592--><!--1593--><!--1594--><!--1595-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >传统的银行受这两家公司的冲击非常大，因为它们有最低成本的零售获客的手段。</span
        >
      </p>
      <!--1596--><!--1597--><!--1598--><!--1599--><!--1600--><!--1601-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1602--><!--1603--><!--1604--><!--1605--><!--1606--><!--1607-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >最近一家叫“趣店”的公司在纳斯达克上市，成立才几年，市值已达100
          亿美元，它本质只是一个阿里流量的贩卖者，但已经可以看出，传统的消费信贷会受到互联网公司的重大冲击。</span
        >
      </p>
      <!--1608--><!--1609--><!--1610--><!--1611--><!--1612--><!--1613-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1614--><!--1615--><!--1616--><!--1617--><!--1618--><!--1619-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我觉得我们可以旁观企业的竞争和兴衰，观察行业的变迁，看到经济的发展，体会到经济的脉搏。</span
        >
      </p>
      <!--1620--><!--1621--><!--1622--><!--1623--><!--1624--><!--1625-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1626--><!--1627--><!--1628--><!--1629--><!--1630--><!--1631-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当然，这个行业也是一个可以高屋建瓴、纸上谈兵、眼高手低的行业，它是一个比较简单而纯粹的工作。本质上，你需要收集数据，需要去自己分析，然后有更多的不同想法，最后得出一个结论。</span
        >
      </p>
      <!--1632--><!--1633--><!--1634--><!--1635--><!--1636--><!--1637-->
    </div>
    
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1686--><!--1687--><!--1688--><!--1689--><!--1690--><!--1691-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong szhuang"
            >五、未来超额收益可能存在于巨大争议中</span
          ></span
        >
      </p>
      <!--1692--><!--1693--><!--1694--><!--1695--><!--1696--><!--1697-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1698--><!--1699--><!--1700--><!--1701--><!--1702--><!--1703-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们来看看美国标准普尔500 指数最大市值的10
          家公司的变迁，体验一下时代的变化（见表11-2）。</span
        >
      </p>
      <img src="../../../assets/img/gar1-2.jpg" alt="">
      <!--1704--><!--1705--><!--1706--><!--1707--><!--1708--><!--1709-->
    </div>
    
    <div class="index-module_mediaWrap_213jB">
      <!--1716--><!--1717-->
      <!--1718--><!--1721--><!--1722--><!--1723-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p">表11-2 标准普尔500指数市值前10大公司变迁</span></p>
      <!--1724--><!--1725--><!--1726--><!--1727--><!--1728--><!--1729-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1730--><!--1731--><!--1732--><!--1733--><!--1734--><!--1735-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >20 世纪80 年代，IBM 和AT&amp;T
          排在前列，它们分别是一家计算机公司和一家电信公司，后面基本都是石油公司。</span
        >
      </p>
      <!--1736--><!--1737--><!--1738--><!--1739--><!--1740--><!--1741-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1742--><!--1743--><!--1744--><!--1745--><!--1746--><!--1747-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >因为20 世纪70 年代能源危机以后，石油价格当时很高。1985 年IBM
          还在第一位，GE
          上来了，到很高的位置，杜邦作为一个化工品公司走出来了，贝尔南方是美国的一家电信公司。</span
        >
      </p>
      <!--1748--><!--1749--><!--1750--><!--1751--><!--1752--><!--1753-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1754--><!--1755--><!--1756--><!--1757--><!--1758--><!--1759-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们可以看到，除了西尔斯是零售公司以外，其他还是以石油公司为主。</span
        >
      </p>
      <!--1760--><!--1761--><!--1762--><!--1763--><!--1764--><!--1765-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1766--><!--1767--><!--1768--><!--1769--><!--1770--><!--1771-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >20 世纪90
          年代的时候已经有了一些变化，百时美施贵宝是一家制药企业，默克是制药企业，我们可以看到消费逐渐走到了前面，可口可乐也是消费公司。</span
        >
      </p>
      <!--1772--><!--1773--><!--1774--><!--1775--><!--1776--><!--1777-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1778--><!--1779--><!--1780--><!--1781--><!--1782--><!--1783-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >到1995
          年的时候，更大的变化是微软、强生出现了，菲利普莫里斯是一家烟草企业。</span
        >
      </p>
      <!--1784--><!--1785--><!--1786--><!--1787--><!--1788--><!--1789-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1790--><!--1791--><!--1792--><!--1793--><!--1794--><!--1795-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >到2000
            年互联网泡沫的时候，互联网企业或者计算机行业的公司，更多的走到了前面，同时我们第一次看到金融行业的公司走到了前十大。</span
          ></span
        >
      </p>
      <!--1796--><!--1797--><!--1798--><!--1799--><!--1800--><!--1801-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1802--><!--1803--><!--1804--><!--1805--><!--1806--><!--1807-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >美国20 世纪90
          年代开始放松金融管制，在这之前美国的金融业也是一个受约束和管制的行业，分业经营、分州经营，没有巨头。</span
        >
      </p>
      <!--1808--><!--1809--><!--1810--><!--1811--><!--1812--><!--1813-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1814--><!--1815--><!--1816--><!--1817--><!--1818--><!--1819-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >90
          年代，格林斯潘的管制放松推动了美国金融行业大规模的并购重组，我们可以看到金融行业开始出现在前十大公司里面。2005
          年，花旗银行、美国银行、AIG 都出来了。</span
        >
      </p>
      <!--1820--><!--1821--><!--1822--><!--1823--><!--1824--><!--1825-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1826--><!--1827--><!--1828--><!--1829--><!--1830--><!--1831-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >2010 年，金融危机之后，苹果公司第一次走上了前台，谷歌也出现了，IBM
          下来了。</span
        >
      </p>
      <!--1832--><!--1833--><!--1834--><!--1835--><!--1836--><!--1837-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1838--><!--1839--><!--1840--><!--1841--><!--1842--><!--1843-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >到2015
          年，互联网企业更多走向了前台，能源公司的数量还在，消费品行业的公司仍然在这个行列里。</span
        >
      </p>
      <!--1844--><!--1845--><!--1846--><!--1847--><!--1848--><!--1849-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1850--><!--1851--><!--1852--><!--1853--><!--1854--><!--1855-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >目前，互联网企业排名靠前，前十大公司分属四个行业：互联网、消费品、医药、金融。</span
        >
      </p>
      <!--1856--><!--1857--><!--1858--><!--1859--><!--1860--><!--1861-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1862--><!--1863--><!--1864--><!--1865--><!--1866--><!--1867-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >所有这些行业本质上都是一个最广大的用户的行业，比如能源，本质上所有人都要用，虽然它是一个B
          端的业务，但本质上是一个C 端的业务。</span
        >
      </p>
      <!--1868--><!--1869--><!--1870--><!--1871--><!--1872--><!--1873-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1874--><!--1875--><!--1876--><!--1877--><!--1878--><!--1879-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >互联网企业更是前所未有地接触到客户，银行业或者金融业本质上也是一个接触到所有用户的一个行业，所以我们看到要成为最大的行业，或者说要成为最大的公司，首先要选择在特定的行业里面。</span
        >
      </p>
      <!--1880--><!--1881--><!--1882--><!--1883--><!--1884--><!--1885-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1886--><!--1887--><!--1888--><!--1889--><!--1890--><!--1891-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >中国所有的行业曾经都是成长性行业，很短的时间走完了发达国家一两百年走过的路，但是所有的行业都会成熟，当它渗透到一定水平的时候，所有行业都会变成成熟的行业。</span
          ></span
        >
      </p>
      <!--1892--><!--1893--><!--1894--><!--1895--><!--1896--><!--1897-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1898--><!--1899--><!--1900--><!--1901--><!--1902--><!--1903-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这个时候，竞争结构和市场占有率就会变成一个行业主导的因素。在成长的阶段拼的是冒险精神，成熟阶段拼的是卓越的运营和有效的管理。</span
        >
      </p>
      <!--1904--><!--1905--><!--1906--><!--1907--><!--1908--><!--1909-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1910--><!--1911--><!--1912--><!--1913--><!--1914--><!--1915-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >而且，我们看到中国的发展一定带来劳动力成本的上涨。</span
        >
      </p>
      <!--1916--><!--1917--><!--1918--><!--1919--><!--1920--><!--1921-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1922--><!--1923--><!--1924--><!--1925--><!--1926--><!--1927-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >劳动力成本的上涨一定会持续的，因为这是国家进步的表现，我们必须要接受劳动力成本的上涨和工资的上涨，企业能够适应这个变化就能够生存，不适应这个变化，就必须被迁移出去。</span
        >
      </p>
      <!--1928--><!--1929--><!--1930--><!--1931--><!--1932--><!--1933-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--1934--><!--1935--><!--1936--><!--1937--><!--1938--><!--1939-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们可以看到，进入稳态之后，行业的回报率会发生重大的变化，标准化的产品往往回报率比较低，个性化的产品往往回报率比较高，品牌会出现溢价。</span
        >
      </p>
      <!--1940--><!--1941--><!--1942--><!--1943--><!--1944--><!--1945-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1946--><!--1947--><!--1948--><!--1949--><!--1950--><!--1951-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >这时候你会发现选择比努力更重要，你在一个比较惨的行业里面，可能只能得到一个比较低的行业的回报率。</span
          ></span
        >
      </p>
      <!--1952--><!--1953--><!--1954--><!--1955--><!--1956--><!--1957-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1958--><!--1959--><!--1960--><!--1961--><!--1962--><!--1963-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这么多年来，或者加入WTO
          以来，中国企业的内部竞争和外部竞争都是非常残酷的，即使国营企业的竞争也是非常残酷的。</span
        >
      </p>
      <!--1964--><!--1965--><!--1966--><!--1967--><!--1968--><!--1969-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1970--><!--1971--><!--1972--><!--1973--><!--1974--><!--1975-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这种激烈的竞争，我觉得就像一个生态系统的自然进化和演化，大家疯狂地抄袭、疯狂地投入，拥有强大的野心或冒险精神，最后的结果会导致相当多资源的浪费，或者是产能过剩。</span
        >
      </p>
      <!--1976--><!--1977--><!--1978--><!--1979--><!--1980--><!--1981-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1982--><!--1983--><!--1984--><!--1985--><!--1986--><!--1987-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >但是整个行业的生产力水平提高了，剩下的公司也会代表行业最高的生产力水平，份额向它们集中，这本身就是社会生产力水平提高的一个过程，也是收入水平整体往前走的必然过程。</span
        >
      </p>
      <!--1988--><!--1989--><!--1990--><!--1991--><!--1992--><!--1993-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--1994--><!--1995--><!--1996--><!--1997--><!--1998--><!--1999-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当然，这个过程总体上促进了社会福利的增加，也能够代表劳动者报酬的提高，但不一定带来股东的回报。</span
        >
      </p>
      <!--2000--><!--2001--><!--2002--><!--2003--><!--2004--><!--2005-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--2006--><!--2007--><!--2008--><!--2009--><!--2010--><!--2011-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >比如这几年光伏行业的发展，短短十年不到的时间，发电的成本降低了60% ～
          70%，但是每个环节都不挣钱，因为产品太高度的标准化。</span
        >
      </p>
      <!--2012--><!--2013--><!--2014--><!--2015--><!--2016--><!--2017-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2018--><!--2019--><!--2020--><!--2021--><!--2022--><!--2023-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >如果我们站在现在的时间往未来看有哪些机会，整个市场会从一个渗透率的故事走向一个市场占有率的故事。</span
          ></span
        >
      </p>
      <!--2024--><!--2025--><!--2026--><!--2027--><!--2028--><!--2029-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2030--><!--2031--><!--2032--><!--2033--><!--2034--><!--2035-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >当渗透率足够高之后，必须从其他人手里面夺取更多的份额，这个时候拼的就是企业的运营能力了。</span
        >
      </p>
      <!--2036--><!--2037--><!--2038--><!--2039--><!--2040--><!--2041-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2042--><!--2043--><!--2044--><!--2045--><!--2046--><!--2047-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >而且必须从中国走向世界，以中国这样一个庞大的母国市场为基础，利用在中国市场上面得到的高生产率水平，在其它国家去扩展，走向全球化，这是公司下一步的机会。到落后国家复制中国的经验，这是一个机会。</span
        >
      </p>
      <!--2048--><!--2049--><!--2050--><!--2051--><!--2052--><!--2053-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2054--><!--2055--><!--2056--><!--2057--><!--2058--><!--2059-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >正如过去几十年来，发达国家在中国曾经走过的路一样，发达国家的投资在中国的实现一样。</span
        >
      </p>
      <!--2060--><!--2061--><!--2062--><!--2063--><!--2064--><!--2065-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--2066--><!--2067--><!--2068--><!--2069--><!--2070--><!--2071-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >在2003 年到2005
          年，我们很不看好自己国家的银行的时候，美国、欧洲为代表的这些巨型跨国企业参股了中国的银行，并得到了超额的回报。</span
        >
      </p>
      <!--2072--><!--2073--><!--2074--><!--2075--><!--2076--><!--2077-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2078--><!--2079--><!--2080--><!--2081--><!--2082--><!--2083-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >在这之前，我们没有自信，但是成熟经济体知道，银行是整个国家经济的一个投影，这个国家在发展的时候，银行一定会受益的。</span
        >
      </p>
      <!--2084--><!--2085--><!--2086--><!--2087--><!--2088--><!--2089-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2090--><!--2091--><!--2092--><!--2093--><!--2094--><!--2095-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我记得一个很有意思的情况，当时建设银行找一些国内公司作为股东的时候，以净资产入股，部分国内公司经过慎重考虑没有同意，认为风险比较大。但最后结果是，美国的银行作为股东参与进来了。</span
        >
      </p>
      <!--2096--><!--2097--><!--2098--><!--2099--><!--2100--><!--2101-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2102--><!--2103--><!--2104--><!--2105--><!--2106--><!--2107-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >此后迎来了中国经济的发展，迎来了银行业回报率的提高，迎来了市值的上涨。这时有非常多的人跳出来说，推动银行业改革的人是在卖国。</span
        >
      </p>
      <!--2108--><!--2109--><!--2110--><!--2111--><!--2112--><!--2113-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2114--><!--2115--><!--2116--><!--2117--><!--2118--><!--2119-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >其实之前说我们自己很烂的和说我们卖国的，可能都是同一批人。我觉得只是说事情发生了，你的态度在发生转变。</span
        >
      </p>
      <!--2120--><!--2121--><!--2122--><!--2123--><!--2124--><!--2125-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2126--><!--2127--><!--2128--><!--2129--><!--2130--><!--2131-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >前述还是从历史经验的角度去判断，其实我们更应该考虑中国发展的经验，能不能在其他落后国家再变现一次。</span
        >
      </p>
      <!--2132--><!--2133--><!--2134--><!--2135--><!--2136--><!--2137-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--2138--><!--2139--><!--2140--><!--2141--><!--2142--><!--2143-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          ><span class="bjh-strong"
            >同时，未来的机会在于创新。要供给创造需求，新的产品才能提供新的需求和市场。其实互联网这个工具让小公司更容易发展成一个中型公司，而发展成一个更大公司很困难，因为满足一些细分的消费者、一些个性化的需求更容易。</span
          ></span
        >
      </p>
      <!--2144--><!--2145--><!--2146--><!--2147--><!--2148--><!--2149-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2150--><!--2151--><!--2152--><!--2153--><!--2154--><!--2155-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >从资本市场来考虑，当市场效率提高的时候，很难创造阿尔法，有可能会走向一个主动去创造阿尔法的过程。</span
        >
      </p>
      <!--2156--><!--2157--><!--2158--><!--2159--><!--2160--><!--2161-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2162--><!--2163--><!--2164--><!--2165--><!--2166--><!--2167-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >美国的3G
          资本其实走出了一条道路，它把企业完全收购，然后经过成本结构的调整，或者是其他一些改造转型来创造阿尔法。</span
        >
      </p>
      <!--2168--><!--2169--><!--2170--><!--2171--><!--2172--><!--2173-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2174--><!--2175--><!--2176--><!--2177--><!--2178--><!--2179-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >可能是因为资本市场的效率太高，委托代理的体制已经不能直接创造更多的超额收益了，必须自己走向前台，长期来看，这也可能是一个方向。</span
        >
      </p>
      <!--2180--><!--2181--><!--2182--><!--2183--><!--2184--><!--2185-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2186--><!--2187--><!--2188--><!--2189--><!--2190--><!--2191-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们总体上面临一个巨大变化的时代，时代确实变了。从前在巴菲特的年代，投资还是少数人的事情，但是在互联网时代，每个人都可以参与。</span
        >
      </p>
      <!--2192--><!--2193--><!--2194--><!--2195--><!--2196--><!--2197-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2198--><!--2199--><!--2200--><!--2201--><!--2202--><!--2203-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >信息的传播速度非常高，固守在原来的思维模式和习惯里面，有可能会无法创造历史上同等水平的超额收益率。未来，超额收益有可能会集中在有巨大的争议或者巨大的不确定性的行业中。</span
        >
      </p>
      <!--2204--><!--2205--><!--2206--><!--2207--><!--2208--><!--2209-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2210--><!--2211--><!--2212--><!--2213--><!--2214--><!--2215-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >这个市场简单的钱一定比过去更难赚，从研究员或者基金经理来说，有可能需要将自己的精力越来越多地投入到创造社会价值增量的行业上去。</span
        >
      </p>
      <!--2216--><!--2217--><!--2218--><!--2219--><!--2220--><!--2221-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"><span class="bjh-br"></span></span>
      </p>
      <!--2222--><!--2223--><!--2224--><!--2225--><!--2226--><!--2227-->
    </div>
    <div class="index-module_textWrap_3ygOc gs">
      <p>
        <span class="bjh-p"
          >我们需要不断地学习，同时在资本市场里一定要独立思考，要藐视权威，用数据和逻辑说话，其他的都要抱一分批判或者怀疑的态度。</span
        >
      </p>
      <!--2228--><!--2229--><!--2230--><!--2231--><!--2232--><!--2233-->
    </div>
    <p class="free">（来源：百话财经）</p>
    <div class="index-module_textWrap_3ygOc gs">
      <p><span class="bjh-p"></span></p>
      <!--2234--><!--2235--><!--2236--><!--2237--><!--2238--><!--2239-->
    </div>
    <!--13--><!--2240--><!--2241-->
  </div>
</template>

<script>
export default {};
</script>

<style>
/* .bjh-strong{
    font-weight:bold;

} */
.index-module_textWrap_3ygOc{
    padding: 10px 0;
}
.index-module_articleWrap_2Zphx{
    color:#6f6f6f;
    font-size: 14px;
    text-indent: 2em;
}
.zhemo{
    text-align: center;
    padding: 40px 0 20px 0;
    font-weight: bold;
    font-size: 16px;
}
.free{
    color:#6f6f6f;
    font-size: 14px;
    text-indent: 0 !important;
    margin-top: 40px;
}
.gs{
    padding: 0;
    min-height: 20px;
}
.szhuang{
    font-weight: bold;
}
</style>